import Template from "./template";

export default {
  path: ":id",
  element: <Template />,
  loader: async ({ params }) => {
    const { id } = params;
    return {
      id,
    };
  },
};
